export default __webpack_public_path__ + "static/media/networking.d76cfb36.jpg";